export default __webpack_public_path__ + "static/media/Imperial-Fleet-03.65a709cf.jpg";